<template lang="pug">
v-app
  v-content
    router-view
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import "./plugins/meltline.css";
@import "@/scss/_variables.scss";

html, body {
  margin: 0;
  height: 100%;
  background: $primary_bg_color;
  -ms-overflow-style: none;    /* IE, Edge 対応 */
  scrollbar-width: none; 
}

html::-webkit-scrollbar {  /* Chrome, Safari 対応 */
  display:none;
}

@import url(http://fonts.googleapis.com/earlyaccess/notosansjapanese.css); /* 源ノ角ゴシック */
body, .application {
  position: relative;
	font-family: 'Noto Sans Japanese', Arial, Verdana, Roboto, "游ゴシック", "Yu Gothic", "游ゴシック体", "YuGothic", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "Meiryo UI", "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  color: $primary_text_color;
}
</style>
